module.exports = __webpack_public_path__ + "img/2025-12-20g_4.946d064c.jpg";